import React from "react";
import Order from "../orders/Order";

function PurchaseOrder() {
  return <Order whichOrder={"purchaseOrder"} />;
}

export default PurchaseOrder;
